// Mantener sincronizado con NON_EXCEPTIONAL_RULES en backend/routes_applications.py
const RULES = [
  { label: "arriendo o dividendo de la vivienda principal", re: /\b(arriendo|arrendamiento|dividendo|hipotec\w*)\b/, housing: true },
  { label: "gastos comunes", re: /\bgastos? comun(es)?\b/, housing: true },
  { label: "cuotas de auto o vehículo", re: /\b(autos?|automovil\w*|automotriz|vehicul\w*|camioneta)\b/ },
  { label: "seguros", re: /\b(seguros?)\b/ },
  { label: "colegio o colegiatura", re: /\b(colegios?|colegiatura|escolar\w*|mensualidad escolar)\b/ },
  { label: "alimentación del hogar", re: /\b(alimentacion|alimentos|comida|supermercado|mercaderia)\b/ },
];

const norm = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export function blockedExpenseReason(expense) {
  const text = norm(expense?.description);
  if (!text) return null;
  const hit = RULES.find((r) => !(r.housing && expense.area === "vivienda_adicional") && r.re.test(text));
  return hit ? hit.label : null;
}
